/**
 * Checks if the enemy is in the filtered enemies list and updates the values accordingly.
 * @param {boolean} actionTypeInputIsInViewMode - Indicates if the action type input is in view mode.
 * @param {object} values - The current values object.
 * @param {function} setValues - The function to update the values object.
 * @param {array} filteredEnemies - The filtered enemies list.
 */
const checkIfEnemyInFilteredEnemies = (
  actionTypeInputIsInViewMode,
  values,
  setValues,
  filteredEnemies,
) => {
  if (!actionTypeInputIsInViewMode) {
    const enemyId = values?.caused?.enemyId || "";
    const caused = {};

    if (
      enemyId.length &&
      filteredEnemies.length &&
      !filteredEnemies.map(({ value }) => value).includes(enemyId)
    ) {
      caused["enemyId"] = "";
      caused["enemyName"] = "";
    }

    if (filteredEnemies.length) {
      setValues((prev) => ({
        ...prev,
        caused: { ...prev?.caused, ...caused },
        shouldCheckEnemyId: true,
      }));
    } else {
      setValues((prev) => ({
        ...prev,
        caused: { ...prev?.caused, ...caused },
        shouldCheckEnemyId: false,
      }));
    }
  }
};

export default checkIfEnemyInFilteredEnemies;
